'use es6';

import { List, OrderedMap, Record } from 'immutable';
import { RequestStatus } from '../constants/base';
import MABExperiment from './MABExperiment';
import MABVariation from './MABVariation';
const DEFAULTS = {
  experiment: new MABExperiment(),
  status: RequestStatus.UNINITIALIZED,
  variants: OrderedMap()
};
export default class MAB extends Record(DEFAULTS) {
  static fromJS({
    mabExperiment,
    master,
    variants
  }) {
    return new MAB({
      experiment: MABExperiment.fromJS(mabExperiment),
      status: RequestStatus.SUCCEEDED,
      variants: List(variants).unshift(master).map(MABVariation.fromJS).reduce((acc, variant) => acc.set(String(variant.id), variant), OrderedMap())
    });
  }
}